import React from "react";
import TitleStripe from "../../common/TitleStripe";
import NoOcurrence from "../../common/query/NoOcurrence";
import PendenciasFinanceiras from "../../common/query/PendenciasFinanceiras";
import { Alert } from "flowbite-react";
import AcoesCiveis from "../../common/query/AcoesCiveis";
import ChequesSemFundos from "../../common/query/ChequesSemFundos";
import Protestos from "../../common/query/Protestos";
import { FaRegChartBar, FaUserCheck } from "react-icons/fa";
import { IoReceiptOutline } from "react-icons/io5";
import { TfiBarChart } from "react-icons/tfi";
import { LuBuilding2 } from "react-icons/lu";
import { BsBank } from "react-icons/bs";
import {
  GrDocumentExcel,
  GrDocumentText,
  GrDocumentTime,
  GrMoney,
} from "react-icons/gr";
import { CiMoneyCheck1 } from "react-icons/ci";
import { MdOutlineBalance } from "react-icons/md";
import { HiOutlineCurrencyDollar } from "react-icons/hi";
import { FiUserCheck, FiUsers } from "react-icons/fi";
import { BiLineChartDown } from "react-icons/bi";

const PendenciasQuod = ({ data }) => {
  return (
    <>
      {data?.statusRetorno == 1 && (
        <>
          <div id="negativacoes-base-4">
            <TitleStripe className="mb-4">
              <div className="flex items-center gap-2">
                <BsBank className="text-blue-700" />
                <span>Pendências Bancárias / Base IV</span>
              </div>
            </TitleStripe>

            {data?.pendenciasFinanceiras?.length > 0 ? (
              <div className="flex gap-2 items-start">
                <div className="flex-1">
                  <PendenciasFinanceiras
                    quantidadeTotal={
                      data?.resumoConsulta?.pendenciasFinanceiras
                        ?.quantidadeTotal
                    }
                    valorTotal={
                      data?.resumoConsulta?.pendenciasFinanceiras?.valorTotal
                    }
                    pendenciasFinanceiras={data?.pendenciasFinanceiras}
                  />
                </div>
              </div>
            ) : (
              <NoOcurrence />
            )}

            <TitleStripe className="mb-5">
              <div id="acoes-base-4" className="flex items-center gap-2">
                <MdOutlineBalance className="text-blue-700" />
                <span>Ações Cíveis / Base IV</span>
              </div>
            </TitleStripe>

            {data?.acoesCiveis?.length > 0 ? (
              <div className="flex gap-2 items-start">
                <div className="flex-1">
                  <AcoesCiveis
                    quantidadeTotal={
                      data?.resumoConsulta?.acoesCiveis?.quantidadeTotal
                    }
                    acoesCiveis={data?.acoesCiveis?.slice(0, 5)}
                  />
                </div>
              </div>
            ) : (
              <NoOcurrence />
            )}

            <TitleStripe className="mb-5">
              <div id="protestos-base-4" className="flex items-center gap-2">
                <GrDocumentExcel className="text-blue-700" />
                <span>Títulos protestados / Base IV</span>
              </div>
            </TitleStripe>

            {data?.protestos?.length > 0 ? (
              <div className="flex gap-2 items-start">
                <div className="flex-1">
                  <Protestos
                    quantidadeTotal={
                      data?.resumoConsulta?.protestos?.quantidadeTotal
                    }
                    valorTotal={data?.resumoConsulta?.protestos?.valorTotal}
                    protestos={data?.protestos}
                    temVencimento={false}
                  />
                </div>
              </div>
            ) : (
              <NoOcurrence />
            )}

            <TitleStripe className="mb-5">
              <div id="ccf-base-4" className="flex items-center gap-2">
                <CiMoneyCheck1 className="text-blue-700" />
                <span>Cheques sem fundo / Base IV</span>
              </div>
            </TitleStripe>

            {data?.chequesSemFundo?.length > 0 ? (
              <div className="flex gap-2 items-start">
                <div className="flex-1">
                  <ChequesSemFundos
                    quantidadeTotal={
                      data?.resumoConsulta?.chequesSemFundo?.quantidadeTotal
                    }
                    valorTotal={
                      data?.resumoConsulta?.chequesSemFundo?.valorTotal
                    }
                    chequesSemFundos={data?.chequesSemFundo?.slice(0, 5)}
                  />
                </div>
              </div>
            ) : (
              <NoOcurrence />
            )}
          </div>
        </>
      )}
    </>
  );
};

export default PendenciasQuod;
